// extracted by mini-css-extract-plugin
module.exports = {"nav":"PurchaseNav_nav__aDq6d","navItem":"PurchaseNav_navItem__sWdA1","active":"PurchaseNav_active__3UIg3"};